import { Box, Paper, useMediaQuery } from "@mui/material";
import { useTheme } from "@mui/material/styles";

export default function GlassCard({ children, sx = {} }) {
  const theme = useTheme();
  const isDark = theme.palette.mode === "dark";
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  if (isMobile) {
    return <Box sx={sx}>{children}</Box>;
  }

  return (
    <Paper
      elevation={0}
      sx={{
        p: 2,
        borderRadius: 3,
        border: isDark
          ? "1px solid rgba(255,255,255,0.08)"
          : "1px solid rgba(0,0,0,0.08)",
        background: isDark
          ? "rgba(255,255,255,0.04)"
          : "rgba(255,255,255,0.75)",
        backdropFilter: "blur(10px)",
        WebkitBackdropFilter: "blur(10px)",
        ...sx,
      }}
    >
      {children}
    </Paper>
  );
}
